import { useTranslation } from 'react-i18next';

export default function SafetySection() {
  const { t } = useTranslation('home');

  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200/70 text-center">
          <span className="w-12 h-12 rounded-full bg-secondary-100 flex items-center justify-center mx-auto mb-4">
            <i className="ri-shield-check-line text-secondary-600 text-xl"></i>
          </span>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-4">
            {t('safety_title')}
          </h2>
          <p className="text-sm text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            {t('safety_text')}
          </p>
        </div>
      </div>
    </section>
  );
}